import { setPath } from "../../utils/paths";
import { BaseStore } from "./base";
export class LocalStore extends BaseStore {
    constructor(glue, params) {
        super(params);
    }
    async setValueCore(params, cb) {
        const path = typeof params === "string" ? params : params.field;
        setPath(this.values, path, params.value);
        this.notifyListeners(path);
    }
}
